import { SearchableText } from "../../../../../shared/components/search/Searchable"
import { StandardChip } from "../../../../../shared/components/badges/StandardChip"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import type { MeetingRoomRow } from "../meetingRoomsTypes"
import { MeetingRoomsListRow } from "./MeetingRoomsListRow"

type MeetingRoomFreeRowProps = Readonly<{
    room: MeetingRoomRow
    trailing: string
    searchRegex?: RegExp
    onOpen: (room: MeetingRoomRow) => void
}>

export function MeetingRoomFreeRow({ room, trailing, searchRegex, onOpen }: MeetingRoomFreeRowProps) {
    const { floorName, seats } = room

    return (
        <MeetingRoomsListRow
            lead={<SearchableText search={searchRegex}>{room.name}</SearchableText>}
            title={
                <LocalizedStrict id="service-center-meeting-rooms-group-hour-free-label">
                    <span>Available</span>
                </LocalizedStrict>
            }
            chip={
                <StandardChip placement="table" size="small" variant="success">
                    <LocalizedStrict id="service-center-meeting-rooms-group-hour-free-label">
                        <span>Available</span>
                    </LocalizedStrict>
                </StandardChip>
            }
            meta={
                seats !== undefined ? (
                    <LocalizedStrict
                        id="service-center-meeting-rooms-table-room-seats"
                        vars={{ floor: floorName, seats }}
                    >
                        <span>
                            {floorName} · {seats}
                        </span>
                    </LocalizedStrict>
                ) : (
                    floorName
                )
            }
            trailing={trailing}
            tag={
                seats !== undefined && (
                    <StandardChip placement="table" size="small" variant="success">
                        <LocalizedStrict id="service-center-meeting-rooms-group-hour-free-seats" vars={{ seats }}>
                            <span>{seats} seats</span>
                        </LocalizedStrict>
                    </StandardChip>
                )
            }
            isHighlighted
            onClick={() => onOpen(room)}
        />
    )
}
